module.exports = __webpack_public_path__ + "media/images/icons/tv-54ab05233c3a2e48cda618e081da88db.svg";